import { useFeatureFlag } from '@/hooks/useFeatureFlag';
import { parseUtcInstant } from '@/utils/wallClock';

import { useShipmentContext } from '../../hooks/useShipmentContext';

import './index.css';

export const ShipmentAdditionalData = () => {
  const { shipment } = useShipmentContext();
  const useLocalTime = useFeatureFlag('Shipping_Additional_Data_Local_Time');

  const formatTimestamp = (value: string | null | undefined) => {
    const date = parseUtcInstant(value);
    if (!date) return null;
    return date.toLocaleString(
      'en-US',
      useLocalTime ? undefined : { timeZone: 'UTC' },
    );
  };

  return (
    <div className="shipment__additional-data">
      <div className="shipment__additional-data__group">
        <div className="shipment__additional-data__item">
          <label>Created By</label>
          <cite>{shipment?.createdBy?.fullName}</cite>
        </div>
        <div className="shipment__additional-data__item">
          <label>Created On</label>
          <time>{formatTimestamp(shipment?.createdOn)}</time>
        </div>
      </div>
      <div className="shipment__additional-data__group">
        <div className="shipment__additional-data__item">
          <label>Modified By</label>
          <cite>{shipment?.modifiedBy?.fullName}</cite>
        </div>
        <div className="shipment__additional-data__item">
          <label>Modified On</label>
          <time>{formatTimestamp(shipment?.modifiedOn)}</time>
        </div>
      </div>
    </div>
  );
};
